import React from 'react'
import Header from '../../common/Header/Header'
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  
} from "react-router-dom";
import Home from '../Home/Home';
import Footer from '../../common/Footer/Footer';
import About from '../About/About';
import Service from '../Service/Service';
import Blog from '../Blog/Blog';
import Pricing from '../Pricing/Pricing';
import Contact from '../Contact/Contact';


const Layout = () => {
  return(
    <div className="app">
      <Header/>
      <Outlet/>
      <Footer/>
    </div>
  )
}

const router = createBrowserRouter([
  {
    path: "/",
    element:<Layout/>,
    children:[
      {
        path:'/',
        element:<Home/>
      },
      {
        path:"/about",
        element:<About/>
      },
      {
        path:"/services",
        element:<Service/>
      },
      {
        path:"/blog",
        element:<Blog/>
      },
      {
        path:"/pricing",
        element:<Pricing/>
      },
      {
        path:"/contact",
        element:<Contact/>
      },
      
    ]
  }
]);

const Pages = () => {
  return (
    <>
       <RouterProvider router={router} />
      
    </>
  )
}

export default Pages
